export default __webpack_public_path__ + "static/media/404_.b441aeae.jpg";